// extracted by mini-css-extract-plugin
export default {"cls1":"PayeeUploadStep-FooterLinks_cls1__nD94J","cls2":"PayeeUploadStep-FooterLinks_cls2__ZisYk PayeeUploadStep-FooterLinks_cls1__nD94J"};